// Blob + object URL + a temporary anchor, no library. The URL is revoked right after the click:
// the browser has the blob by then, and nothing is left to free when the caller forgets
export function downloadBlob(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');

  anchor.href = url;
  anchor.download = fileName;
  anchor.click();

  URL.revokeObjectURL(url);
}
